import { BaseDto } from "@/shared/dtos/base-dto";

export class recurso_data extends BaseDto {
  public dataset_ckan!: string;
  public nombre!: string;
  public refresco!: number;
}
